






































































































/**
 * @copyright       Palace Resorts
 * @description
 * @author
 * @creationDate
 */
import i18nMessages from "./i18n/messages";
import GlobalMixin from "@/mixins/global";
import dataService from "@/services/proveedoresAPI";
import ResponseData from "@/models/store/ProveedoresTypesData";
import SecctionDocuments from "@/models/store/SecctionDocuments";
import DatatableInvoice from "@/components/DatatableInvoice/DatatableRegisterInvoice.vue";
import moment from "moment";
import { assign } from "lodash";
import DatatablePayment from "@/components/DatatablePayment/DatatablePayment.vue";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma.
  i18n: i18nMessages,
  components: {
    DatatableInvoice,
    DatatablePayment,
  },
  props: ["id", "pedido", "folio", "sociedad"],
  data: () => {
    return {
      // GENERAL
      moduleName: "REGISTER_NEW_INVOICE",
      tab: null,
      // PROVEEDOR
      proveedor: {
        userID: "",
        userName: "",
        userProveedorSubcontratacionObra: false,
      },
      doctoSeccion: 5,
      nombreProveedor: "",
      // TABS
      totalpagos: 0,
      totalrdocumentos: 0,
      // DOCUMENTOS POR SECCION
      documentosSeccion: {
        documentoGrupo: [],
      },
      documentoGrupo: [],
      // REGISTRO DOCUMENTOS
      headersRegistroDocumentos: [],
      dataTableDocument: [],
      loadingDocumentos: true,
    };
  },
  methods: {
    init() {
      this.getID();
      this.getDocumentsTypes();
      this.headersRegistroDocumentos = [
        {
          text: "Descripción",
          align: "start",
          value: "docDescripcion",
        },
        {
          text: "Archivo",
          value: "docBucketKeyFile",
          file: true,
        },
        {
          text: "Estatus",
          value: "docEstatusID",
          template: this.getStatus,
          color: this.getColor,
        },
        {
          text: "Acciones",
          value: "actions",
          sortable: false,
        }, 
      ];
    },

    getStatus(value: number) {
      switch (value) {
        case 0:
          return "Inactivo";
          break;
        case 1:
          return "Activo - Pendiente por autorizar";
          break;
        case 2:
          return "Autorizado";
          break;
        case 3:
          return "Rechazado";
          break;
        case 4:
          return "Cancelado por el SAT";
          break;
        default:
          return "Inactivo";
          break;
      }
    },
    getColor(value: number) {
      switch (value) {
        case 0:
          return "blue-grey";
          break;
        case 1:
          return "orange";
          break;
        case 2:
          return "green";
          break;
        case 3:
          return "red";
          break;
        case 4:
          return "red";
          break;
        default:
          return "blue-grey";
          break;
      }
    },

    // PROVEEDOR
    getID() {
      dataService.getByID(this.id).then((Response: ResponseData) => {
        this.proveedor = Response.data.data[0];
        this.nombreProveedor =
          (this.proveedor.userID ?? "") +
          " - " +
          (this.proveedor.userName ?? "");
        return "";
      });
    },

    // DOCUMENTOS POR SECCION
    getDocumentsTypes() {
      dataService
        .getSectionDocuments1(this.doctoSeccion)
        .then((Response: ResponseData) => {
          this.documentosSeccion = Response.data.data[0];
          this.getTableDocumentProvider(this.documentosSeccion.documentoGrupo);

        })
        .catch((e: Error) => {});
    },
    getTableDocumentProvider(documentoGrupo: any) {
      documentoGrupo.forEach((doc: any) => {
        if (doc.documentoOrden == 1) {
          dataService
            .getInvoiceBySupplierAndInvoice(
              this.id,
              doc.documentoTipoID,
              this.folio
            )
            .then((Response: ResponseData) => {
              this.dataTableDocument[doc.documentoTipoID] = Response.data.data;
              this.totalrdocumentos =
                this.totalrdocumentos + Response.data.data.length;
            })
            .catch((e: Error) => {});
        }
      });
      this.loadingDocumentos = false;
    },

    getVisibleDoc(documento: SecctionDocuments) {
      if (
        !this.proveedor.userProveedorSubcontratacionObra &&
        documento.documentoObra
      ) {
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.init();
  },
});
